import type {
  VotePriorityBallot,
  VotePriorityCategory,
  VotePriorityResultsResponse,
} from '@/types/votePriority'

const apiUrl = import.meta.env.VITE_VOTE_PRIORITY_API_URL

function getApiUrl() {
  if (!apiUrl) {
    throw new Error('Falta VITE_VOTE_PRIORITY_API_URL')
  }
  return apiUrl
}

export async function getVotePriorityCategories(): Promise<{
  ok: boolean
  categories: VotePriorityCategory[]
  maxSelections: number
}> {
  const response = await fetch(`${getApiUrl()}?action=categories`)
  if (!response.ok) throw new Error('No se pudieron cargar las categorías')
  return response.json()
}

export async function getVotePriorityResults(): Promise<VotePriorityResultsResponse> {
  const response = await fetch(`${getApiUrl()}?action=results`)
  if (!response.ok) throw new Error('No se pudieron cargar los resultados')
  return response.json()
}

export async function getVotePriorityStatus(voterId: string): Promise<{
  ok: boolean
  voterId: string
  hasVoted: boolean
}> {
  const url = new URL(getApiUrl())
  url.searchParams.set('action', 'status')
  url.searchParams.set('voter_id', voterId)

  const response = await fetch(url.toString())
  if (!response.ok) throw new Error('No se pudo consultar el estado')
  return response.json()
}

export async function submitVotePriority(ballot: VotePriorityBallot) {
  const response = await fetch(getApiUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'text/plain;charset=utf-8',
    },
    body: JSON.stringify(ballot),
  })

  if (!response.ok) throw new Error('No se pudo registrar el voto')
  return response.json()
}

export function getOrCreateVoterId() {
  const key = 'ee26_vote_priority_voter_id'
  const existing = localStorage.getItem(key)

  if (existing) return existing

  const voterId = crypto.randomUUID()
  localStorage.setItem(key, voterId)
  return voterId
}
